/* unplugin-vue-components disabled */import script from "./role-perm-error.vue?vue&type=script&setup=true&lang=js"
export * from "./role-perm-error.vue?vue&type=script&setup=true&lang=js"

import "./role-perm-error.vue?vue&type=style&index=0&id=e5e590a8&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e5e590a8"]])

export default __exports__